import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import TaskGeoTargetState from 'components/Tasks/_common/CheckGeotargetAccess/TaskGeoTargetStateNew';
import { t } from 'utils/translates';

import PopUpLink from '../../../../Common/GlobalPopUps/PopUpLink';

class TasksToExecutorsListItemBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTaskUpListPopUp: false
    };
  }

  render() {
    return (
      <React.Fragment>
        <div className="row offset_bottom offset_bottom_xs">
          <div className="col-xs-24 col-sm-12">
            <dl className="dl-options dl-options-sm dl-horizontal task-options-left">
              <dt title={t('Категория')}>{t('Категория')}:</dt>
              <dd>{this.props.task.task_type_desc}</dd>
              <dt title={t('Проверка')}>{t('Проверка')}:</dt>
              <dd>{this.props.task.check_type_desc}</dd>
              <dt title={t('Многоразовость')}>{t('Многоразовость')}:</dt>
              <dd>{this.props.task.executor_execution_interval_desc}</dd>
            </dl>
          </div>
          <div className="col-xs-24 col-sm-12">
            <dl className="dl-options dl-options-sm dl-horizontal task-options-right">
              <dt title={t('Время выполнения')}>{t('Время выполнения')}:</dt>
              <dd>{this.props.task.time_perform_desc}</dd>
              <dt title={t('Таргетинг по времени')}>
                {t('Таргетинг по времени')}:
              </dt>
              <dd>
                {this.props.task.has_time_target > 0 ? (
                  <PopUpLink
                    hashName="getTimeTarget"
                    hashParams={{ id: this.props.task.id }}
                  >
                    {t('<span class="text-success">Есть</span>, узнать')}
                  </PopUpLink>
                ) : (
                  <React.Fragment>{t('Нет')}</React.Fragment>
                )}
              </dd>
              <dt title={t('Геотаргетинг')}>{t('Геотаргетинг')}:</dt>
              <dd>
                <TaskGeoTargetState
                  task_id={this.props.task.id}
                  has_geo_target={this.props.task.has_geo_target}
                />
              </dd>
            </dl>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TasksToExecutorsListItemBody.defaultProps = {
  refreshTaskItem: () => {}
};

TasksToExecutorsListItemBody.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    task_type_desc: PropTypes.string.isRequired,
    check_type_desc: PropTypes.string.isRequired,
    executor_execution_interval_desc: PropTypes.string.isRequired,
    time_perform_desc: PropTypes.string.isRequired,
    tasksExecsStat: PropTypes.shape({}).isRequired,
    has_time_target: PropTypes.bool.isRequired,
    has_geo_target: PropTypes.bool.isRequired,
    has_mark_hide: PropTypes.bool.isRequired,
    has_mark_chosen: PropTypes.bool.isRequired,
    updatedAt: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(TasksToExecutorsListItemBody);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksToExecutorsList/TasksToExecutorsListItem/TasksToExecutorsListItemBody/index.js